import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import ShoppingCommentTimelineItem from '@/components/shoppings/ShoppingCommentTimelineItem';
import useUser from '@/hooks/useUser';
import { useUiStatus } from '@/hooks/useUiStatus';
import { likeCommentShopping } from '@/domains/firestore/user';
import { updateCommentCountShopping } from '@/domains/firestore/comment';
import { fetchComments } from 'src/actions/comment';
import { Comment } from '@/domains/firestore/comment';

type ComponentProps = {
  comment: Comment;
  shoppingId: string;
};

const ShoppingCommentTimelineItemContainer: React.FC<ComponentProps> = ({
  comment,
  shoppingId
}) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { setModalState } = useUiStatus();
  const user = useUser();
  const handleOnRequestUpdateLike = useCallback(
    async (commentId: string) => {
      if (!user) {
        setModalState(true);
      } else {
        setLoading(true);
        const liked = await likeCommentShopping({ commentId, userId: user.uid });
        Promise.all([updateCommentCountShopping({ postId: shoppingId, commentId, liked })]).then(
          async () => {
            await dispatch(updateUser(user.uid));
            await dispatch(fetchComments(shoppingId));
          }
        );
        setLoading(false);
      }
    },
    [dispatch, setModalState, shoppingId, user]
  );
  const isLiked = user?.liked.includes(comment.commentId) || false;

  return (
    <ShoppingCommentTimelineItem
      comment={comment}
      onRequestUpdateLike={handleOnRequestUpdateLike}
      isLiked={isLiked}
      invalid={isLoading}
    />
  );
};

export default ShoppingCommentTimelineItemContainer;
